import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Server = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Server' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M14,19 L15,19 L15,18 L14,18 L14,19 Z M5,23 L19,23 L19,1 L5,1 L5,23 Z M8,5 L16,5 L8,5 Z M8,9 L16,9 L8,9 Z M8,13 L16,13 L8,13 Z' />
  </StyledIcon>
);
